import * as React from "react";
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  Link as MUILink,
  Paper,
  Box,
  Grid,
  Typography,
  Alert,
  AlertTitle,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import SettingsPowerIcon from "@mui/icons-material/SettingsPower";
import { Link } from "react-router-dom";
import "@mui/styles";
import hashData from "../services/encrypt";
import ResetPassword from "../services/API/ResetPassword";

function Copyright(props: any) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <MUILink color="inherit" href="https://www.slicoinsurance.com/">
        SLICO
      </MUILink>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const ResetUser = () => {
  const [errorMsg, setErrorMsg] = React.useState<string>("");
  const [formValues, setFormValues] = React.useState({
    email: "",
    activationCode: "",
    passwordNew: "",
    passwordConfirm: "",
  });
  const theme = useTheme();

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };
  const CloseAlert = () => setErrorMsg("");
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (formValues.passwordNew !== formValues.passwordConfirm) {
      setErrorMsg("Passwords do not Match");
    } else {
      const hash = hashData(formValues.passwordNew, false);
      if (hash) {
        ResetPassword({
          Email: formValues.email,
          ActivationCode: formValues.activationCode,
          NewPassword: hash,
        }).then((response) => {
          if (response) {
            setErrorMsg(response);
          }
        });
      }
    }
  };

  return (
    <Grid
      container
      component="main"
      sx={{ minHeight: "100vh", background: theme.palette.background.default }}
    >
      <CssBaseline />
      <Grid
        item
        xs={12}
        sm={8}
        md={5}
        component={Paper}
        elevation={8}
        square
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          background: theme.palette.background.paper,
          borderRadius: { xs: 0, sm: 4 },
          boxShadow: { xs: "none", sm: 6 },
          minHeight: { xs: "100vh", sm: "auto" },
          p: { xs: 2, sm: 4 },
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 400,
            mx: "auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar
            variant="circular"
            alt="SLICO"
            src="/slico_logo.jpg"
            sx={{
              width: 120,
              height: 120,
              mb: 2,
              boxShadow: 3,
              bgcolor: theme.palette.background.default,
            }}
          />
          <Typography
            component="h1"
            variant="h5"
            sx={{ fontWeight: 700, mb: 1, color: theme.palette.primary.main }}
          >
            Activate Your Account
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mb: 2, textAlign: "center" }}
          >
            Enter your email, activation code, and set a new password.
          </Typography>
          <Box
            component="form"
            noValidate
            onSubmit={handleSubmit}
            sx={{ width: "100%" }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              onChange={handleChange}
              value={formValues.email}
              variant="outlined"
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="activationCode"
              label="Activation Code"
              name="activationCode"
              autoComplete="activation-Code"
              type="text"
              onChange={handleChange}
              value={formValues.activationCode}
              variant="outlined"
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="passwordNew"
              label="New Password"
              autoComplete="password-New"
              type="password"
              id="passwordNew"
              onChange={handleChange}
              value={formValues.passwordNew}
              variant="outlined"
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="passwordConfirm"
              label="Confirm Password"
              type="password"
              autoComplete="password-Confirm"
              id="passwordConfirm"
              onChange={handleChange}
              value={formValues.passwordConfirm}
              variant="outlined"
            />
            {errorMsg && (
              <Alert severity="info" onClose={CloseAlert} sx={{ mt: 2 }}>
                <AlertTitle>Info</AlertTitle>
                {errorMsg}
              </Alert>
            )}
            <Button
              color="primary"
              type="submit"
              variant="contained"
              sx={{ mt: 3, mb: 2, fontWeight: 600, letterSpacing: 1 }}
              endIcon={<SettingsPowerIcon />}
              fullWidth
              size="large"
            >
              Activate Account
            </Button>
            <Grid container spacing={2} sx={{ mt: 1, mb: 2 }}>
              <Grid item xs={12}>
                <Link style={{ textDecoration: "none" }} to="/Login">
                  <Button color="secondary" fullWidth variant="text">
                    Sign In
                  </Button>
                </Link>
              </Grid>
            </Grid>
            <Copyright sx={{ mt: 4, mb: 1 }} />
          </Box>
        </Box>
      </Grid>
      <Grid
        item
        xs={false}
        sm={4}
        md={7}
        sx={{
          backgroundImage: "url(/background.jpg)",
          backgroundRepeat: "no-repeat",
          backgroundColor:
            theme.palette.mode === "light"
              ? theme.palette.grey[50]
              : theme.palette.grey[900],
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "100vh",
        }}
      />
    </Grid>
  );
};
export default ResetUser;
